module.exports = __webpack_public_path__ + "static/colgadas-007.thumb-83f63c341eaaeedef7d798990ba02340.jpg";